<ion-header class="no-shadow">
  <ion-toolbar>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content" [class.large]="large">
  <p class="message">{{ message }}</p>

  <div class="actions">
    <ion-button fill="clear" class="btn-cancel" (click)="dismiss(false)">
      <span class="btn-text">{{ noText }}</span>
    </ion-button>
    <ion-button class="btn-confirm" [class.btn-confirm--danger]="yesVariant === 'danger'" (click)="dismiss(true)">
      {{ yesText }}
    </ion-button>
  </div>
</div>